"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Select = _interopRequireDefault(require("../../../elements/select/Select"));
var _formActions = require("../../../redux/actions/form/formActions");
var _redirect = _interopRequireDefault(require("../../../utils/redirect/redirect"));
var _formAutoFillModule = _interopRequireDefault(require("./form-auto-fill.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["pathname"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getSelectOptions(id, mockDataObject) {
  if (mockDataObject && mockDataObject[id]) {
    var label = id === 'urlQueryParams' ? '- query params -' : '- autofill -';
    var options = Object.keys(mockDataObject[id]).map(function (key) {
      return {
        value: key,
        label: key
      };
    });
    return [{
      value: '',
      label: label
    }].concat(_toConsumableArray(options));
  }
  return [];
}
function getAutoFillData(id, key, initialValues, formValues, mockDataObject) {
  if (!key) {
    return undefined;
  }
  var existingValuesToKeep = Object.keys(formValues || {}).reduce(function (acc, key) {
    return mockDataObject[id][key] === undefined ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, formValues[key])) : acc;
  }, {});
  return _objectSpread(_objectSpread(_objectSpread({}, existingValuesToKeep), initialValues), mockDataObject[id][key]);
}
function getUrlWithQueryString(id, key, mockDataObject) {
  if (!key) {
    return undefined;
  }
  var mockData = mockDataObject[id][key];
  if (!mockData) {
    return '';
  }
  var _mockData$pathname = mockData.pathname,
    pathname = _mockData$pathname === void 0 ? window.location.pathname : _mockData$pathname,
    params = _objectWithoutProperties(mockData, _excluded);
  var search = Object.keys(params).reduce(function (acc, key) {
    if (acc.length > 1) {
      acc = "".concat(acc, "&");
    }
    return "".concat(acc).concat(key, "=").concat(params[key]);
  }, '?');
  return "".concat(window.location.origin).concat(pathname).concat(search);
}
var FormAutoFill = /*#__PURE__*/function (_PureComponent) {
  function FormAutoFill() {
    var _this;
    _classCallCheck(this, FormAutoFill);
    _this = _callSuper(this, FormAutoFill);
    _defineProperty(_this, "onChange", function (event) {
      var _this$props = _this.props,
        id = _this$props.id,
        initialValues = _this$props.initialValues,
        formValues = _this$props.formValues,
        resetForm = _this$props.resetForm;
      if (event) {
        var value = event.target.value;
        var mockDataObject = _this.state.mockData;
        if (id === 'urlQueryParams') {
          var url = getUrlWithQueryString(id, value, mockDataObject);
          if (url) {
            (0, _redirect["default"])(url);
          }
          return;
        }
        var data = getAutoFillData(id, value, initialValues, formValues, mockDataObject);
        resetForm(id, data);
      }
    });
    _this.state = {
      mockData: FormAutoFill.mockData
    };
    return _this;
  }
  _inherits(FormAutoFill, _PureComponent);
  return _createClass(FormAutoFill, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _window$env,
        _this2 = this;
      var mockData = this.state.mockData;
      var mockDataLocation = ((_window$env = window.env) === null || _window$env === void 0 ? void 0 : _window$env.MOCKDATA_LOCATION) || '/mockData.json';
      if (!mockData) {
        window.fetch(mockDataLocation).then(function (response) {
          return response.json().then(function (response) {
            FormAutoFill.mockData = response;
            _this2.setState({
              mockData: response
            });
          })["catch"](function () {
            // eslint-disable-next-line no-console
            console.warn("Can not load ".concat(mockDataLocation, " - auto fill will not work"));
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id;
      var mockDataObject = this.state.mockData;
      var options = getSelectOptions(id, mockDataObject);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select["default"], {
        id: "".concat(id, "-autoFill"),
        name: "".concat(id, "-autoFill"),
        value: "",
        className: _formAutoFillModule["default"].select,
        onChange: this.onChange,
        options: options
      });
    }
  }]);
}(_react.PureComponent);
_defineProperty(FormAutoFill, "propTypes", {
  id: _propTypes["default"].string.isRequired,
  initialValues: _propTypes["default"].objectOf(_propTypes["default"].string),
  formValues: _propTypes["default"].objectOf(_propTypes["default"].string),
  resetForm: _propTypes["default"].func
});
_defineProperty(FormAutoFill, "defaultProps", {
  initialValues: {},
  formValues: {},
  resetForm: function resetForm() {}
});
_defineProperty(FormAutoFill, "mockData", undefined);
var _default = exports["default"] = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    formValues: (0, _get["default"])(state, "form.".concat(ownProps.id, ".values"), {})
  };
}, {
  resetForm: _formActions.resetForm
})(FormAutoFill);